import React from "react";
import AgreementListPage from "Containers/Agreement/ViewPage";
import AgreementAddPage from "Containers/Agreement/AgreementAdd";

const Actions = {
  agreement: {
    view: {
      codenames: [],
      action_code: "visible_agreement_view",
      is_superuser_action: false,
      name: "View Agreement List",
      label: "Agreements",
      action: "sub-menu",
      url: "/agreement/list",
      component: <AgreementListPage />,
      permission_needed: true,
      associated_urls: ["/agreement/add", "/agreement/preview"],
    },
    create: {
      codenames: [],
      action_code: "visible_agreement_add",
      is_superuser_action: false,
      name: "Create Agreement",
      label: "Agreements",
      action: "action-url",
      url: "/agreement/add",
      component: <AgreementAddPage />,
      permission_needed: true,
      associated_urls: ["/agreement/preview"],
    },
    name: "Agreements",
    type: "Basic Details",
  },
};

export default Actions;


